<div class="skin-default card-no-border">

  <!--div class="preloader">
      <div class="loader">
          <div class="loader__figure"></div>
          <p class="loader__label">Contractors Management</p>
      </div>
  </dsiv-->

  <section id="wrapper">
      <div class="login-register" style="background-image:url(/assets/images/background/bg.jpg);">
          <div class="row">
              <div class="col-lg-6 paddingtittle">
                  <img class="mb-4 loginlogo" src="/assets/images/ceslogo.png" width="200" alt="">
                  <h5 class="supertittle">
                    Contractors Management
                  </h5>
              </div>
              <div class="col-lg-6">
                  <div class="login-box card p-20 mt-5">
                      <div class="card-body">
                              <h3 class="box-title m-b-20">Sign In</h3>
                              <div class="form-group ">
                                <div class="col-xs-12">
                                  <input
                                    class="form-control"
                                    type="text"
                                    required
                                    placeholder="Username"
                                    [(ngModel)]="username"
                                    [ngModelOptions]="{standalone: true}"
                                  />
                                </div>
                              </div>

                              <div class="form-group">
                                <div class="col-xs-12">
                                  <input
                                    class="form-control"
                                    type="password"
                                    required
                                    placeholder="Password"
                                    [(ngModel)]="password"
                                    [ngModelOptions]="{standalone: true}"
                                  />
                                </div>
                              </div>
                              <div class="form-group text-center">
                                  <div class="col-xs-12 p-b-20">
                                      <button class="btn btn-block btn-lg btn-danger" type="submit" (click)="login()">Log In</button>
                                  </div>
                              </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>
  </section>

  <script type="text/javascript">
  $(function() {
      $(".preloader").fadeOut();
  });
  $(function() {
      $('[data-toggle="tooltip"]').tooltip()
  });

  $('#to-recover').on("click", function() {
      $("#loginform").slideUp();
      $("#recoverform").fadeIn();
  });
  $('#close').on("click", function() {
      $("#loginform").slideDown();
      $("#recoverform").fadeOut();
  });
  </script>
</div>
